import { useEffect } from 'react';
import PopupService from '../services/PopupService';

export function useClosePopup(onClose, onMountCb?, onUnmountCb?) {

    useEffect(() => {
        PopupService.listenEscPressed(onClose);
        if (onMountCb) {
            onMountCb();
        }
        return () => {
            if (onUnmountCb) {
                onUnmountCb();
            }
            PopupService.stopListenEscPressed(onClose);
        };
    }, [onClose]);
}